import React, { useState, useEffect } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const operators = [
    // "Sigalagala",
    // "Hapung",
    "Paranjulu",
    "Binanga",
    "Portibi"
];

const UpdateUangBongkarPage = () => {
    const [selectedOperator, setSelectedOperator] = useState(operators[0]);
    const [uangBongkar, setUangBongkar] = useState("");
    const [latestUangBongkar, setLatestUangBongkar] = useState({});
    const [status, setStatus] = useState("");

    useEffect(() => {
        const fetchUangBongkar = async () => {
            try {
                const res = await axios.get(`${API_URL}/api/uangbongkar/${selectedOperator}`);
                setLatestUangBongkar(prev => ({
                    ...prev,
                    [selectedOperator]: res.data.uangBongkarPerKg
                }));
            } catch {
                setLatestUangBongkar(prev => ({
                    ...prev,
                    [selectedOperator]: null
                }));
            }
        };
        if (selectedOperator) fetchUangBongkar();
    }, [selectedOperator]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/uangbongkar`, {
                operator: selectedOperator,
                uangBongkarPerKg: uangBongkar
            });
            setStatus("✅ Uang bongkar berhasil diperbarui.");
            setLatestUangBongkar(prev => ({
                ...prev,
                [selectedOperator]: uangBongkar
            }));
            setUangBongkar("");
        } catch (err) {
            setStatus("❌ Gagal memperbarui uang bongkar.");
        }
    };

    return (
        <div className="container mt-4">
            <h3>Update Uang Bongkar per Kg</h3>
            <div className="mb-3">
                <label className="form-label">Pilih Operator</label>
                <select
                    className="form-select"
                    value={selectedOperator}
                    onChange={e => setSelectedOperator(e.target.value)}
                >
                    {operators.map(op => (
                        <option key={op} value={op}>{op}</option>
                    ))}
                </select>
            </div>
            <p>
                Uang Bongkar Terakhir: {latestUangBongkar[selectedOperator] !== undefined && latestUangBongkar[selectedOperator] !== null
                    ? `Rp ${latestUangBongkar[selectedOperator]}`
                    : "Belum ada data"}
            </p>
            <form onSubmit={handleSubmit}>
                <input
                    type="number"
                    className="form-control"
                    placeholder="Masukkan uang bongkar per Kg"
                    value={uangBongkar}
                    onChange={e => setUangBongkar(e.target.value)}
                    required
                />
                <button type="submit" className="btn btn-primary mt-2">Update Uang Bongkar</button>
            </form>
            {status && <p className="mt-3">{status}</p>}
        </div>
    );
};

export default UpdateUangBongkarPage;